import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion, ServiceList } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../providers/shared.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { CustomConfirmDialogComponent } from '../custom-confirm-dialog/custom-confirm-dialog.component';
@Component({
  selector: 'sm-inventory-items-for-misc',
  templateUrl: './inventory-items-for-misc.component.html',
  styleUrls: ['./inventory-items-for-misc.component.scss']
})
export class InventoryItemsForMiscComponent implements OnInit, OnDestroy {
  public inventoryListData: any = {}
  public newInventoryData: any = {for_sale:0}
  isDiscount!: boolean;
  isShop: boolean = false
  isHome: boolean = false
  isPercent!: boolean
  isAmount!: boolean
  isHomeSpecific: Boolean = false;
  isShopSpecific: Boolean = false;
  entityHash: string = '';
  operation_type: any
hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public page: number = 1;
  inventoryItems: any[] = [];
  inventoryTemplateData: any[] = [];
  selectedInventoryData: any[] = [];
  selectedInventoryTemplateData: any[] = [];
  datalength!: number
  toShowInventoryItems: boolean = true
  toShowInventoryTemplate: boolean = true
  showInventoryAdd: boolean = false
  searchString: FormControl = new FormControl('');
  loading: boolean = false
  isfrohere:boolean = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    public dialog: MatDialogRef<InventoryItemsForMiscComponent>,
    private activemodal: MatDialogRef<InventoryItemsForMiscComponent>,
    private _modelRef:MatDialog
  ) {}
  removeAsset() {
    this.inventoryListData.imgUrl = '';
    this.assetList = [];
  }
  ngOnInit(): void {


    
    
    console.log(this.parentData);
    this.operation_type = this.parentData.operation_type
    if(this.parentData.operation_type == 4){
      this.toShowInventoryItems = false
      this.toShowInventoryTemplate = this.parentData.toShowTemplate
    }
    else if(this.parentData.operation_type != 4){
      this.toShowInventoryItems = this.parentData.toShowTemplate
      this.toShowInventoryTemplate = false
    }
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHash = data.entityHash
      if(this.toShowInventoryItems){
        this.loading = true
        this._apiService.getInventoryItems(this.entityHash,this.page,this.searchString.value ?? '');
      }
      if(this.toShowInventoryTemplate){
        this.loading = true
        this._apiService.getInventoryTemplateDataByKeyword(this.page,this.searchString.value ?? '')
      }
      
    })
    let data: any = new ServiceList();
    Object.assign(data, this.parentData.inventoryData);
    console.log(data);
    if (data.hash_id) {

      if(data.image_url && data.image_url != 'null'){
        this.assetList.push({
          assetName: data?.image_url
            .split('/')
            .pop()
            .substring(data.image_url.split('/').pop().lastIndexOf('_') + 1),
          url: data?.image_url,
          thumbnail: data?.image_thumb_url
        });
      }
      
        this.newInventoryData.hash_id = data.hash_id,
        this.newInventoryData.item_name = data.item_name,
        this.newInventoryData.item_desc = data.item_desc,
        this.newInventoryData.qty_info = data.quantity_info,
        this.newInventoryData.purchase_unit = data.purchase_unit,
        this.newInventoryData.min_stock = data.min_stock,
        this.newInventoryData.current_stock = data.current_purchase_stock,
        this.newInventoryData.current_selling_stock = data.current_selling_stock,
        this.newInventoryData.selling_purchase_multiplier = data.selling_purchase_multiplier,
        this.newInventoryData.selling_unit = data.selling_unit,
        this.newInventoryData.for_sale = data.for_sale,
        this.editMode = true;
    }
    if(data.shopStatus == 1){
      this.isShop = true
      let eve = {
        checked: true,
        source: {
          value: 'shop'
        }
      }
      this.change(eve);
    }
    if(data.homeStatus == 1){
      this.isHome = true
      let eve = {
        checked: true,
        source: {
          value: 'home'
        }
      }
      this.change(eve);
    }
    if(data.discountStatus ==1){
      this.isDiscount = true
    }
    if(data.discountStatus == 0 ){
      this.isDiscount = false
    } 
    if(data.discountType == 2 ){
      this.isAmount = true
    }
    if(data.discountType == 1 ){
      this.isPercent = true
    }

    
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList = []
        this.assetList = [{
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        }]
        this.inventoryListData.imgUrl = res.result?.url;
        this.loader = false;
      }
   
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS){
       

        // this.inventoryItems = []
        console.log(res);
       if(res.result){
        this.datalength = res.result[0].totalCount
        // this.datalength = 0
        res.result.forEach((element:any) => {
          element.selected = false
          this.inventoryItems.push(element)
        });
       }
       else{
        this.datalength = 0
       }
        this.loading = false
        this.loaderservice.showLoader = false
        
      }
      if(res.responseType === SM_CONSTANTS.RESULT_API_GET_INVENTORY_TEMPLATE_DATA_BY_KEYWORD){
       

        // this.inventoryTemplateData = []
        console.log(res);
       if(res.result){
        this.datalength = res.result[0].totalCount
        // this.datalength = 0
        res.result.forEach((element:any) => {
          element.selected = false
          this.inventoryTemplateData.push(element)
        });
       }
       else{
        this.datalength = 0
       }
       this.loading = false
      this.loaderservice.showLoader = false
        
      }
      else if(res.responseType === SM_CONSTANTS.RESULT_API_SET_INVENTORY_ITEM_ACTIVITY){
        if(res.result && res.result != null){
          this.parentData.ref.closeAll();
        }
      }
      else if(res.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INVENTORY_ITEM){
        if(this.isfrohere){
          this.isfrohere = false
          if(res.result && res.result != null){
             if(res.result.errorcode == 0){
               this.activemodal.close({msg:'success'})

             }
             else{
              this.loaderservice.showLoader = false
              const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
                width:'450px',
                data : {
                  title : 'Alert!',
                  message : 'The item is linked with a selling product. Edit or delete not possible. Either you need to delete the product first from Product section or create a new item instead.',
                  okbtn : 'Ok',
                  cancelbtn : 'Cancel',
                  type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
                },
                disableClose : true
              });
             }
          }

        }
      }
    });
  }
  isForSale:boolean = false
  change(event:any){
    console.log(event);
    if(event.checked == true){
      this.newInventoryData.for_sale = 1
    } if(event.checked == false ){
      this.newInventoryData.for_sale = 0
    }
    
  }

  onApp(event:any){

    if(event.target.value == 'applicable' ){
      this.inventoryListData.discountStatus = 1
    }if(event.target.value == 'not-applicable'){
      this.inventoryListData.discountStatus = 0
      this.inventoryListData.discountAmount = null
      this.inventoryListData.discountType = null
      this.isPercent = false
      this.isAmount = false
      this.inventoryListData.homeDiscountedPrice = null
      this.inventoryListData.shopDiscountedPrice = null
    }

  }

  typeofactivity:any //1= selling unit, 2 = purchase unit
  discType(event:any){
    if(event.target.value == '1' ){
      this.typeofactivity= 1
    }if(event.target.value == '2'){
      this.typeofactivity = 2
    }

  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
           this.inventoryItems = []
           this.page = 1
  }
  onAddEditInventoryItem(){
      
    if(this.editMode){ 
      let multiplier = this.newInventoryData.for_sale == 0 ? 1 : (this.newInventoryData.purchase_unit == this.newInventoryData.selling_unit ? 1 : +this.newInventoryData.selling_purchase_multiplier )
      let current_selling_stock = this.newInventoryData.for_sale == 0 ? +this.newInventoryData.current_stock :  this.newInventoryData.current_stock * multiplier  
      let bodyData = {  
        "entity_hash_id": this.entityHash,
        "hash_id": this.newInventoryData.hash_id,
        "item_name": this.newInventoryData.item_name,
        "item_desc": this.newInventoryData.item_desc,
        "min_stock": +this.newInventoryData.min_stock,
        "img_url": this.assetList.length > 0 ?  this.assetList[0].url : null,
        "thumb_url": this.assetList.length > 0 ?  this.assetList[0].thumbnail : null,
        "status": 1,
        "current_selling_stock": current_selling_stock,
        "current_purchase_stock": +this.newInventoryData.current_stock,
        "selling_purchase_multiplier": multiplier ,
        "purchase_unit": this.newInventoryData.purchase_unit,
        "selling_unit": this.newInventoryData.for_sale == 0 ? this.newInventoryData.purchase_unit : this.newInventoryData.selling_unit,
        "qty_info": this.newInventoryData.for_sale == 0 ? 1 : this.newInventoryData.qty_info,
        "for_sale": this.newInventoryData.for_sale
      } 
        console.log(bodyData);
        
        this.isfrohere = true
        this.loaderservice.showLoader = true
        this._apiService.addEditInventoryItem(bodyData)
    }
    else{
      let multipler = this.newInventoryData.for_sale == 0 ? 1 : (this.newInventoryData.purchase_unit == this.newInventoryData.selling_unit ? 1 : +this.newInventoryData.selling_purchase_multiplier )
      let current_selling_stock =this.newInventoryData.for_sale == 0 ? +this.newInventoryData.current_stock : this.newInventoryData.current_stock * multipler
      
      let bodyData = {
        "entity_hash_id": this.entityHash,
        "item_name": this.newInventoryData.item_name,
        "item_desc": this.newInventoryData.item_desc,
        "qty_info": this.newInventoryData.for_sale == 0 ? 1 : this.newInventoryData.qty_info,
        "purchase_unit": this.newInventoryData.purchase_unit,
        "selling_unit": this.newInventoryData.for_sale == 0 ? this.newInventoryData.purchase_unit : this.newInventoryData.selling_unit,
        "current_selling_stock": +current_selling_stock,
        "current_purchase_stock": +this.newInventoryData.current_stock,
        "selling_purchase_multiplier": multipler,
        "min_stock": +this.newInventoryData.min_stock,
        "img_url": this.assetList.length > 0 ?  this.assetList[0].url : null,
        "thumb_url": this.assetList.length > 0 ?  this.assetList[0].thumbnail : null,
        "status": 1,
        "for_sale": this.newInventoryData.for_sale
      }
        console.log(bodyData);
        this.isfrohere = true
        this.loaderservice.showLoader = true
        this._apiService.addEditInventoryItem(bodyData)
    }
  }
  onPost() {
    let s_qty
    let p_qty  
    if(this.typeofactivity == '1'){//selling unit
      s_qty = +this.inventoryListData.qty
      p_qty = Math.round((this.inventoryListData.qty/this.selectedInventoryData[0].selling_purchase_multiplier)*100)/100
    } else if(this.typeofactivity == '2'){//purchase unit
      p_qty = +this.inventoryListData.qty
      s_qty = Math.round((this.inventoryListData.qty*this.selectedInventoryData[0].selling_purchase_multiplier)*100)/100
    }
    if(this.operation_type == 2){ //decrease

      let bodydata = {
        "entity_hash_id": this.entityHash,
        "inventory_hash_id": this.selectedInventoryData[0].inventory_hash_id,
        "inventory_items_hash_id": this.selectedInventoryData[0].hash_id,
        "operation_type": 2,
        "createdByHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "notes": this.inventoryListData.notes ?? '' ,
        "barcode": this.inventoryListData.barcode ?? '',
        "purchase_quantity": p_qty,
        "selling_quantity": s_qty,
        "selling_unit": this.selectedInventoryData[0].selling_unit,
        "purchase_unit": this.selectedInventoryData[0].purchase_unit
      }
  
      console.log(bodydata);
      this.loaderservice.showLoader = true;
      this._apiService.setInventoryItemActivity(bodydata)

    }
    else if (this.operation_type == 1){ //increase
      let bodydata = {
        "entity_hash_id": this.entityHash,
        "inventory_hash_id": this.selectedInventoryData[0].inventory_hash_id,
        "inventory_items_hash_id": this.selectedInventoryData[0].hash_id,
        "operation_type": 1,
        "createdByHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "notes": this.inventoryListData.notes ?? '' ,
        "barcode": this.inventoryListData.barcode ?? '',
        "purchase_quantity": p_qty,
        "selling_quantity": s_qty,
        "selling_unit": this.selectedInventoryData[0].selling_unit,
        "purchase_unit": this.selectedInventoryData[0].purchase_unit
      }
  
      console.log(bodydata);
      this.loaderservice.showLoader = true;
      this._apiService.setInventoryItemActivity(bodydata)
    }
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  selectInventoryTemplate(item:any){
    this.selectedInventoryData = []
    this.inventoryItems.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.selectedInventoryData.push(item)
    if(this.selectedInventoryData[0].purchase_unit == this.selectedInventoryData[0].selling_unit){
      this.typeofactivity = 2
      this.inventoryListData.qty = null
      this.inventoryListData.notes = null
      this.inventoryListData.barcode = null
    }
    else{
      this.typeofactivity = null
      this.inventoryListData.qty = null
      this.inventoryListData.notes = null
      this.inventoryListData.barcode = null
    }

  }
  selectInventoryTemplateDataByKeyword(item:any){
    this.selectedInventoryTemplateData = []
    this.inventoryTemplateData.forEach((element:any) => {
      element.selected = false
    });
    item.selected = true

    this.selectedInventoryTemplateData.push(item)
    

  }

  onSelectNext(){
    this.toShowInventoryItems = false
  }
  onSelectNextOnTemplateData(){
    

    //map for edit

    this.newInventoryData.item_name = this.selectedInventoryTemplateData[0].item_name
    this.newInventoryData.item_desc = this.selectedInventoryTemplateData[0].item_desc
    // this.newInventoryData.qty_info = this.selectedInventoryTemplateData[0].quantity_info

    this.assetList = []
    if(this.selectedInventoryTemplateData[0].image_url && this.selectedInventoryTemplateData[0].image_thumb_url != 'null'){
      this.assetList.push({
        assetName: this.selectedInventoryTemplateData[0]?.image_url
          .split('/')
          .pop()
          .substring(this.selectedInventoryTemplateData[0].image_url.split('/').pop().lastIndexOf('_') + 1),
        url: this.selectedInventoryTemplateData[0]?.image_url,
        thumbnail: this.selectedInventoryTemplateData[0]?.image_thumb_url,
      });
    }

    this.toShowInventoryTemplate = false
    this.showInventoryAdd = true
  }

  back(){
    this.toShowInventoryItems=true

   
  }
  backFromInventoryTemplate(){
    this.showInventoryAdd = false
    this.toShowInventoryTemplate=true

   
  }

  seeMore() {
    this.page += 1;
    this.loaderservice.showLoader = true;
    // this.loading = true;
       if (this.toShowInventoryItems) {
        // this.loading = true;
        this._apiService.getInventoryItems(
          this.entityHash,
          this.page,
          this.searchString.value ?? ""
        );
      }
      if (this.toShowInventoryTemplate) {
        // this.loading = true;
        this._apiService.getInventoryTemplateDataByKeyword(
          this.page,
          this.searchString.value ?? ""
        );
      }
  }
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getServiceTemplates(this.page)
  }

  reset(){
    this.inventoryTemplateData = []
    this.inventoryItems = []
    this.loading = true
    this.searchString.reset()
    this.page = 1
    if(this.parentData.operation_type == 4){
      this._apiService.getInventoryTemplateDataByKeyword(this.page,this.searchString.value ?? '')
    }
    else{
      this._apiService.getInventoryItems(this.entityHash,this.page,this.searchString.value ?? '');
    }

  }
  firstTimeBelow3:boolean = false;
 debounceTimer: any; // Declare this at the class level
  searchServiceData() {
    clearTimeout(this.debounceTimer); // Clear previous timer

    this.debounceTimer = setTimeout(() => {
      if (this.searchString.value.length >= 3) {
        this.loading = true;
        this.inventoryTemplateData = [];
        this.inventoryItems = []
        this.firstTimeBelow3 = true;
        this.page = 1;
        if (this.parentData.operation_type == 4) {
          this._apiService.getInventoryTemplateDataByKeyword(
            this.page,
            this.searchString.value ?? ""
          );
        } else {
          this._apiService.getInventoryItems(
            this.entityHash,
            this.page,
            this.searchString.value ?? ""
          );
        }
      } else {
        if (this.firstTimeBelow3) {
          this.loading = true;
          this.inventoryTemplateData = [];
          this.inventoryItems = []
          this.firstTimeBelow3 = false;
          this.page = 1;
          if (this.parentData.operation_type == 4) {
            this._apiService.getInventoryTemplateDataByKeyword(this.page, "");
          } else {
            this._apiService.getInventoryItems(this.entityHash, this.page, "");
          }
        }
      }
    }, 300); // Delay in ms
  }

}

